<div class="container-box">
  <app-table-header (btnUpdateClick)="reloadTrigger$.next()" tableTitle="Quadrature Cassa">
    <button
      (click)="openDeleteCashFundsDialog()"
      action-button
      class="btn btn-danger inline-grid items-center"
    >
      Cancella fondi cassa
    </button>
  </app-table-header>
  <div class="table-container">
    <app-table-group-rows
      (buttonClick)="downloadExcelExport($event)"
      (secondButtonClick)="createCashFound($event)"
      [columns]="columns"
      [data]="data"
      [icon]="faFileExcel"
      [showButtonRow]="true"
      [showSecondButtonRow]="true"
      [subColumns]="subColumns"
      [subRowName]="'movimenti'"
    ></app-table-group-rows>
  </div>
</div>
